(function () {
    'use strict';

    angular
        .module('app')
        .component('feedRssFormAdmin', {
            templateUrl: 'app/components/feedrss/admin/feedrss/feed-rss-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                permisosCategoria: '<',
                categorias: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, ModalService, CATEGORIA_RSS_FORM_ADMIN) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/feedRss/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        vm.openCategoriaModal = function () {
            ModalService.openComponent('feedsRss.categoriaRss.admin.create.title', CATEGORIA_RSS_FORM_ADMIN, {}).result.then(function (result) {
                // Asociamos el nuevo elemento a la entidad
                vm.categorias.push(result);
                vm.item.categoriaRss = result;
            });
        };

    }

})();
